import React from "react";
import { History } from "lucide-react";

export default function DkGecmisPanel({ gecmisHesaplar, plaka }) {
    if (!gecmisHesaplar?.length) return null;
    return (
        <div className="rounded-xl border border-amber-500/15 bg-amber-500/5 p-3 space-y-2">
            <div className="text-xs font-medium text-amber-200 flex items-center gap-2">
                <History className="h-3.5 w-3.5" />
                Plaka geçmişi {plaka ? `(${plaka})` : ""}
            </div>
            <div className="flex flex-wrap gap-2">
                {gecmisHesaplar.map((g) => (
                    <div
                        key={g.deger_kaybi_id}
                        className="text-[10px] px-2 py-1 rounded border border-white/10 text-slate-400"
                    >
                        {g.dosya_no}: <span className="text-emerald-300">{g.gercek_fmt}</span>
                    </div>
                ))}
            </div>
        </div>
    );
}
